import { BaseModel } from "model/BaseModel";

export default class ClassificacaoRequisito implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    descricao: string;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        descricao = '',
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.descricao = descricao;
    }
}
